// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_pa-0";
export var animationContainer = "_pa-1";
export var itemPrice = "_pa-a";
export var itemizedContent = "_pa-9";
export var itemizedHeader = "_pa-7";
export var itemizedRow = "_pa-8";
export var itemizedSection = "_pa-6";
export var modalContent = "_pa-2";
export var orderName = "_pa-3";
export var refundOption = "_pa-4";
export var refundOptionsContainer = "_pa-5";
export var shippingLabel = "_pa-b";
export var totalRow = "_pa-c";